export const DOMAIN = 'consentConfigDetails.consents';
